import { InfoIconButton } from "src/components/InfoIconButton";

type PageTitleProps = {
  iconClickHandler: () => unknown;
};

export default ({ iconClickHandler }: PageTitleProps) => (
  <span className="inline-flex items-center justify-center">
    Do you have any dependents?
    <InfoIconButton
      marginLeft="8px"
      onClick={iconClickHandler}
      data-testid="dependents-info-icon"
      tabIndex={0}
    />
  </span>
);
